export const VERSION_NUMBER = process.env.REACT_APP_VERSION_INFO;